<template>
  <Filial />
</template>

<script>
import Filial from "./Filial.vue";

export default {
  components: { Filial },
  mounted() {
    this.$store.dispatch("MenuParametrizacaoIncludes/atualizarMenuParaAreaDeFilial", this.$route.path);
  },
}
</script>

<style>

</style>
